import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface HeaderContainerProps {
  children: React.ReactNode;
}

const ContainerComponent: React.FC<HeaderContainerProps> = ({ children }) => {
  return <div className="peptalk-chat-header-container">{children}</div>;
};

export const Container: React.FC<HeaderContainerProps> = (
  props: HeaderContainerProps
) => {
  const Component = useCustomComponent({
    componentName: 'HeaderContainer',
    Component: ContainerComponent,
  });

  return <Component {...props} />;
};


